import React from 'react';
import { Table, Empty, Button, Input, Form, Tooltip } from 'antd';
import { GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';

export default function DetalleProductoServicioModal(props) {
    return (
        <div>
            <Table
                className={'table-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.idProducto}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: 40,
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Remover">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onRemove(row.idProducto)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Código',
                        dataIndex: 'codigo',
                        key: 'codigo',
                        align: 'center',
                        width: 100,
                        ellipsis: true
                    },
                    {
                        title: 'Nombre',
                        dataIndex: 'nombre',
                        key: 'nombre',
                        width: 420,
                        ellipsis: true,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {
                                        props.onGetFieldDecorator(`arrNombre[${row.nombre}]`, {
                                            initialValue: value
                                        })(
                                            <Input
                                                placeholder="Nombre"
                                                autoComplete="off"
                                                className="text-left"
                                                readOnly={true}
                                                onClick={(e) => props.onChangeNameProduct(row)}
                                            />
                                        )
                                    }
                                    
                                </Form.Item>
                            )
                        }
                    },
                    {
                        title: 'Unidad Medida',
                        dataIndex: 'nombreUnidadMedida',
                        key: 'nombreUnidadMedida',
                        width: 180,
                        ellipsis: true
                    },
                    {
                        title: 'Cantidad',
                        dataIndex: 'cantidad',
                        key: 'cantidad',
                        align: 'center',
                        width: 90,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrCantidad[${row.idProducto}]`, {
                                        initialValue: parseFloat(value).toFixed(0),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: "Formato (0)"
                                        }]
                                    })(
                                        <Input
                                            placeholder="Cantidad"
                                            autoComplete="off"
                                            className="text-right"
                                            onBlur={(e) => props.onCalculateDetail(row.idProducto, "arrCantidad", e.target.value, 0, row)}
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    
                ]}
            />
        </div>
    );
}